import { render, staticRenderFns } from "./StopIcon.vue?vue&type=template&id=0c21168c"
import script from "./StopIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./StopIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports